import Cookies from 'js-cookie'

const logout = () => {
  Cookies.remove('userCookie', {
    domain: process.env.REACT_APP_AUTH_COOKIE_DOMAIN
  })
  window.location.reload()
}
export { logout }
